var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "boss-main-content-wrap" },
    [
      _vm.isCompanyStaffAccess
        ? _c("setting-header", {
            staticClass: "hide-for-print",
            attrs: {
              breadcrumbs: [
                { name: "求人確認" },
                { name: "掲載前の求人", pathName: "jobPrePublished" },
              ],
              title: "掲載前の求人プレビュー",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "grid-x hide-for-print",
          attrs: { "data-test": "usage-notes-and-print-button" },
        },
        [
          _c(
            "div",
            { staticClass: "cell auto pega-usage-notes" },
            [
              _vm.hasWritePermission
                ? _c(
                    "mini-accordion",
                    {
                      attrs: {
                        "wrap-class": "pega-accordion-no-line",
                        "head-class": "pega-accordion-link-header",
                        title: "利用方法・注意事項",
                      },
                      on: { toggle: _vm.setLine, toggled: _vm.setLine },
                    },
                    [
                      _c("ul", { staticClass: "pega-disc-list" }, [
                        _c("li", [
                          _vm._v(
                            "コメント・ハイライトモードONの状態で、文字を選択すると、その位置にハイライトとコメントが作成できます。"
                          ),
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _vm._v(
                            "企業様管理画面で作成したハイライトは青、営業・制作担当者は緑で表示されます。"
                          ),
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _vm._v(
                            "コメント・ハイライトモードONの状態で、ハイライト済みの文字をクリックすると、ハイライトを削除することができます。"
                          ),
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _vm._v(
                            "コメント・ハイライトモードをOFFにすることで、コメントを隠してレイアウトを確認することができます。"
                          ),
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _vm._v(
                            "ハイライト・残文字数表示・コメントは、掲載時には表示されません。"
                          ),
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _vm._v(
                            "お使いのブラウザによってはどのハイライトに対するコメントかを示す線が表示されない場合があります。推奨環境（Google Chrome）をご利用くださいますようお願いいたします。"
                          ),
                        ]),
                        _vm._v(" "),
                        _c("li", [_c("job-preview-provision-list-link")], 1),
                      ]),
                    ]
                  )
                : _c("job-preview-provision-list-link"),
            ],
            1
          ),
          _vm._v(" "),
          _c("print-button", {
            staticClass: "cell shrink",
            attrs: { "is-simple": false },
            on: { print: _vm.print },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "grid-x margin-bottom-1",
          attrs: { "data-test": "button-area" },
        },
        [
          _c("div", { staticClass: "cell hide-for-print" }, [
            _vm.isFinishCreated && _vm.hasWritePermission
              ? _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "scroll-to",
                        rawName: "v-scroll-to",
                        value: { el: "#message", offset: -35 },
                        expression: "{ el:'#message', offset: -35}",
                      },
                    ],
                    staticClass:
                      "boss-button-center boss-icon-message pega-preview-jump-button pega-red-button",
                    attrs: { "data-test": "message-jump" },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.businessesPartnerName) +
                        "担当者とのメッセージはこちら\n      "
                    ),
                  ]
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "cell hide-for-print" },
            [
              _c("sp-preview-button", {
                attrs: {
                  id: Number(_vm.jobId),
                  "route-name": _vm.spRouteNameForJob,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "cell pega-text-small" }, [
            _vm._v(
              "\n      ※「インタビュー」「フォトクリップ」は掲載時ご利用の場合のみ表示されます。\n    "
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm.highlightMode
        ? _vm._l(_vm.rects, function (rect, i) {
            return _c("job-preview-comment-line", {
              key: i,
              attrs: { rect: rect },
            })
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isFinishCreated
        ? _c(
            "div",
            {
              class: { "pega-show-highlight": _vm.highlightMode },
              attrs: { id: _vm.topParentHighlightId },
              on: {
                select: _vm.selected,
                click: function ($event) {
                  return _vm.selected($event)
                },
              },
            },
            [
              _c("job-preview", {
                class: _vm.highlightMode ? "pega-cursor-pen-only-id" : "",
                attrs: {
                  offer: _vm.offer,
                  "comment-highlights": _vm.commentHighlights,
                  "highlight-mode": _vm.highlightMode,
                },
                on: {
                  addComment: _vm.addComment,
                  changeComment: _vm.changeComment,
                  deleteComment: _vm.deleteComment,
                  deleteThread: _vm.deleteCommentThread,
                  onLoadImage: _vm.onLoadImageAction,
                  setLine: _vm.setLine,
                  toggleFixed: _vm.toggleFixed,
                  toggleThread: _vm.toggleThread,
                },
              }),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _c("job-matching", {
                class: _vm.highlightMode ? "pega-cursor-pen-only-id" : "",
                attrs: {
                  "job-category-settings": _vm.offer.jobCategorySettings,
                  matching: _vm.matching,
                  "comment-highlights": _vm.commentHighlights,
                  "highlight-mode": _vm.highlightMode,
                },
                on: {
                  addComment: _vm.addComment,
                  changeComment: _vm.changeComment,
                  deleteComment: _vm.deleteComment,
                  deleteThread: _vm.deleteCommentThread,
                  setLine: _vm.setLine,
                  toggleFixed: _vm.toggleFixed,
                  toggleThread: _vm.toggleThread,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isFinishCreated && _vm.hasWritePermission
        ? _c("job-pre-published-preview-message", {
            staticClass: "pega-table margin-bottom-3",
            attrs: { id: "message" },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.hasWritePermission
        ? _c(
            "div",
            {
              staticClass: "pega-commit-comment hide-for-print",
              attrs: { "data-test": "commit-comment" },
            },
            [
              _c("div", [
                _c(
                  "span",
                  {
                    staticStyle: {
                      "font-size": "0.9rem",
                      color: "white",
                      "vertical-align": "super",
                    },
                  },
                  [_vm._v("コメント・ハイライトモード")]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "switch tiny" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.highlightMode,
                        expression: "highlightMode",
                      },
                    ],
                    staticClass: "switch-input",
                    attrs: { id: "tinySwitch", type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(_vm.highlightMode)
                        ? _vm._i(_vm.highlightMode, null) > -1
                        : _vm.highlightMode,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.highlightMode,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.highlightMode = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.highlightMode = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.highlightMode = $$c
                        }
                      },
                    },
                  }),
                  _vm._v(" "),
                  _vm._m(1),
                ]),
              ]),
              _vm._v(" "),
              _c("div", [
                _c(
                  "button",
                  {
                    staticClass: "boss-button pega-button",
                    attrs: {
                      disabled: !_vm.isExistsPendingComment,
                      "data-test": "comment-button",
                    },
                    on: { click: _vm.updateComment },
                  },
                  [
                    _c("span", { staticClass: "boss-button-confirm-text" }, [
                      _vm._v("\n          コメントを確定する\n        "),
                    ]),
                  ]
                ),
              ]),
            ]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "pega-hide-msg" }, [
      _vm._v(
        "\n      これ以降は、女の転職typeのユーザー画面では表示されません。ただし、提携サイトには表示される場合がございます。"
      ),
      _c("br"),
      _vm._v("\n      あらかじめご了承ください。\n    "),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      { staticClass: "switch-paddle", attrs: { for: "tinySwitch" } },
      [
        _c(
          "span",
          { staticClass: "switch-active", attrs: { "aria-hidden": "true" } },
          [_vm._v("ON")]
        ),
        _vm._v(" "),
        _c(
          "span",
          { staticClass: "switch-inactive", attrs: { "aria-hidden": "true" } },
          [_vm._v("OFF")]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }